import { useCurrentTime } from '../../../hooks/use-current-time';
import { useDuration } from '../../../hooks/use-duration';

export const useProgressWidthInPercentages = () => {
    const duration = useDuration();
    const currentTime = useCurrentTime();

    return duration.getPercentFromTime(currentTime);
};
